const map = {
	"./en/00.intro.md": 90540,
	"./en/01.psychometry.md": 39962,
	"./en/02.why_test.md": 11041,
	"./en/03.interpret.md": 83374,
	"./en/04.communicate.md": 81759,
	"./en/05.remember.md": 77026,
	"./en/06.job_analysis.md": 29420,
	"./nb/00.intro.md": 61645,
	"./nb/01.personlighetstesten.md": 88146,
	"./nb/02.evnetesten.md": 28912,
	"./nb/03.hvorfor_teste.md": 0,
	"./nb/04.jobbanalyse.md": 77095,
	"./nb/05.tolkning.md": 26096,
	"./nb/06.kommunisere.md": 4702,
	"./nb/07.husk.md": 80129
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87448;